import React from 'react';
import {MediaContent} from "../../services/GlobalFunctions";
import './BlockImgTxt.scss';

interface Props {
  image: string;
  content: string;
}

const BlockImgTxt = ({image, content}: Props) => {
  return (
    <div className="block-imgtxt__form-director">
      {MediaContent(<span></span>, null)}
      {MediaContent(<span className="block-imgtxt__bg-director"></span>, null)}
      {MediaContent(
        <img
          src={image}
          className="block-imgtxt__form-director-photo"
          alt=""
        />,
        null
      )}
      <div className="block-imgtxt__form-director-content">
        <div dangerouslySetInnerHTML={{__html: content}}></div>
        {MediaContent(
          null,
          <div className="block-imgtxt__form-director-span-height">
            <img
              src={image}
              className="block-imgtxt__form-director-photo"
              alt=""
            />
            <span className="block-imgtxt__bg-director"></span>
          </div>
        )}
      </div>
    </div>
  );
}

export default BlockImgTxt;
